import React from 'react';
import ReactDOM from 'react-dom/client';

// Polyfill para React 19 - findDOMNode não existe mais
if (typeof ReactDOM.findDOMNode === 'undefined') {
    console.log('🔧 Aplicando polyfill para findDOMNode (React 19)');

    const findDOMNode = (instance) => {
        if (!instance) return null;

        // 1. Se já for um elemento DOM
        if (instance.nodeType === 1) {
            return instance;
        }

        // 2. Se for uma ref React (React.useRef)
        if (instance.current) {
            return instance.current;
        }

        // 3. Se for um elemento HTML nativo
        if (instance instanceof HTMLElement || instance instanceof SVGElement) {
            return instance;
        }

        // 4. Tenta acessar propriedades comuns de componentes
        if (instance.input) {
            return instance.input;
        }

        if (instance.refs && instance.refs.input) {
            return instance.refs.input;
        }

        // 5. Para componentes React, tenta acessar o DOM node internamente
        try {
            if (instance._reactInternals) {
                let fiber = instance._reactInternals;
                while (fiber && !fiber.stateNode) {
                    fiber = fiber.child;
                }
                return fiber ? fiber.stateNode : null;
            }
        } catch (e) {
            // Ignora erros
        }

        console.warn('⚠️ findDOMNode não conseguiu encontrar nó DOM para:', instance);
        return null;
    };

    // Adiciona ao ReactDOM
    ReactDOM.findDOMNode = findDOMNode;

    // Adiciona também ao React para compatibilidade
    if (typeof React.findDOMNode === 'undefined') {
        React.findDOMNode = findDOMNode;
    }
}

export default {};
